<template>
    <div class="cost-detail-row cost-detail-row-block" v-if="eurobonusSupported">
        <div class="shopping-cart-coupon-row">
            <div class="cart-coupon-code-trigger">
                <template v-if="!eurobonusEnabled">
                    <label v-if="!eurobonusEnabled" class="cart-coupon-trigger-label cart-coupon-trigger-label-disabled">
                        {{ resources.eurobonusMainLabelDisabled }}
                    </label>
                </template>
                <template v-if="eurobonusEnabled">
                    <template v-if="!eurobonusCodeValue && formCollapsed">
                        <div class="cart-coupon-code-trigger">
                            <label class="cart-coupon-trigger-label">
                                {{ resources.eurobonusMainLabel }}
                            </label>
                            <button type="button" class="cart-coupon-trigger-btn" @click="showForm">
                                {{ resources.showFieldCTA }}
                            </button>
                        </div>
                    </template>
                    <template v-if="eurobonusCodeValue || !formCollapsed">
                        <div class="cart-coupon-code-trigger">
                            <label v-if="eurobonusCodeValue" class="cart-coupon-trigger-label">
                                {{ resources.eurobonusMainLabelApplied }}
                            </label>
                            <label v-if="!eurobonusCodeValue" class="cart-coupon-trigger-label">
                                {{ resources.eurobonusMainLabelApply }}
                            </label>
                            <button type="button" class="no-icon cart-coupon-trigger-btn" @click="removeEurobonus">
                                {{ resources.hideFieldCTA }}
                            </button>
                        </div>
                    </template>
                </template>
            </div>
            <span v-html="resources.eurobonusInfo" class="body-copy-desc-info">
            </span>
            <div v-if="eurobonusEnabled && !formCollapsed && !eurobonusCodeValue" class="cart-coupon-code">
                <form class="rituals-form" novalidate="novalidate" @submit.prevent="applyEurobonus">
                    <fieldset>
                        <div :class="['coupon-wrapper', {'has-error': showError}]">
                            <div class="coupon-input coupon-input-number">
                                <div class="coupon-input-field">
                                    <label class="cart-coupon-trigger-label">
                                        {{ resources.eurobonusInputLabel }}
                                    </label>
                                    <input type="text" class="inputfield-text" :placeholder="resources.eurobonusInputLabel" maxlength="9" minlength="9" size="28" v-model="eurobonusCode" />
                                    <span v-if="showError" class="input-field-error">
                                        {{ errorMessage }}
                                    </span>
                                </div>
                            </div>
                            <div class="coupon-btn">
                                <button class="btn">
                                    <div :class="['spinner', 'white-spinner', {'spinner-visible': showSpinner}]">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>

                                    <template v-if="!showSpinner">
                                        {{ resources.applyCTA }}
                                    </template>
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
        <div v-if="eurobonusEnabled && eurobonusCodeValue" class="cart-coupon-account-number">
            <span> {{ resources.eurobonusCodeValueLabel }}</span>
        </div>
    </div>
</template>
<script src="./eurobonus-form.js"/>
